export default function MyDate() {
    const date = new Date();
        const year = date.getFullYear();
            return year;
}
